/**
 * @fileoverview Prompt template for world-set-snapshotter-v3.
 */

export const prompt = `
You are an expert continuity supervisor and production designer, tracking how environments change and evolve throughout a story. Think like a script supervisor noting how the set has been rearranged between takes.

## TASK INSTRUCTIONS:
Your task is to analyze the provided chapter and update the world set's state to reflect any changes to the environment.

1. Review the set's previous state (if available).
2. Read the chapter content carefully.
3. Determine if this environment:
   - Appears or is described in this chapter
   - Has undergone physical changes (objects moved, damage, decoration changes)
   - Has shifted in atmosphere, lighting, or mood
   - Has new sensory details revealed (sounds, smells, temperature changes)
   - Is affected by weather, time of day, or seasonal changes
4. Update each relevant field to reflect the state of this environment AT THE END of this chapter.
5. If the set does not appear in this chapter, set "notPresentInChapter" to true and carry forward the previous state.

**Important Guidelines:**
- Only update fields where there's evidence of change or new detail
- Preserve existing information unless explicitly contradicted
- Track cumulative changes (e.g., a room that was tidy in Chapter 1 and trashed in Chapter 3 should reflect the damage)
- Note how the environment reflects or contrasts with the emotional state of scenes within it
- Be specific about sensory changes (e.g., "The candles have burned low, casting longer shadows" not just "lighting changed")

## SET INFORMATION

**Name:** {{worldSet.name}}
**Type:** {{worldSet.element}}
**Initial Description:** {{worldSet.initialDescription}}

## PREVIOUS STATE (Before Chapter {{chapterNumber}})

{{#if previousSnapshot}}
{{{json previousSnapshot}}}
{{else}}
No previous snapshot - this is the set's first chapter appearance.
{{/if}}

## CHAPTER CONTENT

{{{chapterContent}}}

## CONTEXT

<<<loreContext>>>

## OUTPUT INSTRUCTIONS:
Update each of the following fields to reflect the state of this environment at the END of Chapter {{chapterNumber}}.

{{#each setFields}}
- **{{this.label}}** (key: {{this.key}}): {{{this.description}}}
{{/each}}

If the set does not appear in this chapter, set "notPresentInChapter" to true.

Provide your output in the required JSON format.
`;
